import React, { useEffect, useState } from "react";
import NutritionalSupport from "../assets/keyfeautures/nutritionsupport.png";
import calorie from "../assets/keyfeautures/calorie.png";
import variety from "../assets/keyfeautures/vareity.png";
import hotfresh from "../assets/keyfeautures/hotfreshmeals.png";
import breakfast from "../assets/bhookrpromise/breaafast.png";
import bf from "../assets/bhookrpromise/bf.jpg";
import lunch from "../assets/bhookrpromise/lunch.png";
import dinner from "../assets/bhookrpromise/dinner.png";
import Faqs from "../global/FAQSection";
import "./home.css";
import HomepageSlider from "../global/HomepageSlider";
import Counter from "../global/Countup";
import before from "../assets/bhookrpromise/Bhookr Before .png";
import SchittsCreekTitle from "../global/SchittsCreekTitle";
import lapbanner from "../assets/clients/latopbannerfinal.jpg";
import mobilebanner from "../assets/clients/mobilebannerFinal.jpg";
import { useNavigate } from "react-router-dom";

// import dammy1 from "../assets/dammy/dammy1.png";
// import dammy2 from "../assets/dammy/damm2.png";
// import dammy3 from "../assets/dammy/damm3.png";
// import dammy4 from "../assets/dammy/damm4.png";
import axios from "axios";
// import Checkout from "../subscription/Checkout";

const Home = () => {
  const [splashscreen, setsplashscreen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handlecheckout = async (amount) => {
    console.log(amount);
    try {
      const response = await axios.post(
        `http://127.0.0.1:5001/bookhr-7756b/us-central1/api/payment/recivepayment`,
        amount
      );
      window.location.href = response.data;
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    }
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const navigate = useNavigate();
  const handleSubscriptionClick = () => {
    navigate("/subscription");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const hasShownSplashscreen =
      localStorage.getItem("splashscreen") === "true";
    const lastShownTime = localStorage.getItem("splashscreenTimestamp");

    const currentTime = Date.now();

    const oneHourInMillis = 60 * 60 * 1000;
    const hasExpired =
      lastShownTime && currentTime - lastShownTime > oneHourInMillis;

    if (!hasShownSplashscreen || hasExpired) {
      setsplashscreen(true);

      const timer = setTimeout(() => {
        setsplashscreen(false);
        localStorage.setItem("splashscreen", "true");
        localStorage.setItem("splashscreenTimestamp", currentTime);
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, []);

  if (splashscreen) return <SchittsCreekTitle />;

  return (
    <div className="maindiv home">
      <div className="homehero">
        <img
          src={isMobile ? mobilebanner : lapbanner}
          alt="banner"
          loading="lazy"
          className="banner"
        />
      </div>
      <section className="whybhookr">
        <h2 className="">Why Bhookr?</h2>
        <div>
          <img src={before} alt="before" loading="lazy" />
          <div>
            <h4 className="text-center">
              {" "}
              “I have lost 20kgs with BHOOKR , Now its your turn”
            </h4>
            <p className="text-center">Pranay kumar</p>
          </div>
        </div>
        <div className="btncontainerhome">
          <button
            className="homerefbtn bhhokrpromisebtn"
            onClick={() => handleSubscriptionClick()}
          >
            Subscribe Now
          </button>
        </div>
      </section>
      <section className="bhhokrpromise">
        <h2>Bhookr Promise</h2>
        <div className="maingrid">
          <div>
            <h3>
              We promise Hot Fresh instant Trust <br />
            </h3>
            <div className="priceconatiner">
              <Counter endValue={189} />
            </div>
          </div>
          <div className="grid">
            <div className="">
              {/* <h4>breakfast</h4> */}
              <img src={bf} alt="breakfast" loading="lazy" />
              <p className="text-center">Spinach fritata</p>
              <p className="text-center text-[#de0101]">
                Protein : <strong>20gm</strong>
              </p>
              <p className="text-center text-[#de0101]">
                Calories: <strong>360k</strong>
              </p>
            </div>
            <div className="">
              {/* <h4>lunch</h4> */}
              <img src={lunch} alt="breakfast" loading="lazy" />
              <p className="text-center">Chickeb burrito bowl</p>
              <p className="text-center text-[#de0101]">
                Protein : <strong>35gm</strong>
              </p>
              <p className="text-center text-[#de0101]">
                Calories: <strong>490k</strong>
              </p>
            </div>
            <div className="">
              {/* <h4>dinner</h4> */}
              <img src={dinner} alt="breakfast" loading="lazy" />
              <p className="text-center">Grilled chicken salad</p>
              <p className="text-center text-[#de0101]">
                Protein : <strong>35gm</strong>
              </p>
              <p className="text-center text-[#de0101]">
                Calories: <strong>450k</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="btncontainerhome">
          <button
            className="homerefbtn bhhokrpromisebtn"
            onClick={() => handleSubscriptionClick()}
          >
            Book your meal now
          </button>
        </div>
      </section>
      <section className="taglinehome">
        <HomepageSlider />
        <button
          className="homerefbtn shadowdisablebtn"
          onClick={() => handleSubscriptionClick()}
        >
          Subscribe Now
        </button>
      </section>

      {/* <section className="dammyPrdoucts">
        <h2>Subscribe now</h2>
        <div className="procductContainer">
          <div>
            <h4>Weight Loss Meals</h4>
            <ul>
              <li>
                <strong>What we offer</strong>
                Low-carb, balanced meals, and keto options.
              </li>
              <li>
                <strong>Why it’s ideal : </strong>Designed to meet daily calorie
                and protein needs with fiber-rich, low-oil, and tasty recipes.
              </li>
              <li>
                <strong>Perfect for : </strong>Access to basic meal options
                (low-calorie, protein-rich).
              </li>
              <li>
                <strong>Meals per week : </strong>Delivery within a 5 km radius.
              </li>
              <li>
                <strong>Price : </strong> ₹5000
              </li>
              <h5>Key Highlights</h5>
              <p>Average 25g protein per meal.</p>
              <p>
                Flexible meal selection (choose from breakfast, lunch, or
                dinner).
              </p>
              <p>Delivery within a 5 km radius.</p>
            </ul>
            <button onClick={() => handlecheckout(5000)}>Subscribe Now</button>
          </div>
          <div>
            <h4>Healthy Lifestyle Meals</h4>
            <ul>
              <li>
                <strong>What we offer : </strong>Low-carb and balanced meals to
                keep you energized throughout the day.
              </li>
              <li>
                <strong>Why it’s ideal : </strong>A perfect balance of protein,
                fiber, and carbs to keep your energy up and your day on track.
              </li>
              <li>
                <strong>Perfect for : </strong>Maintaining a healthy, active
                lifestyle.
              </li>
              <li>
                <strong>Meals per week : </strong>10 meals (5 dinners, 5
                lunches)
              </li>
              <li>
                <strong>Price : </strong> ₹10000
              </li>
              <h5>Key Highlights</h5>
              <p>Average 35g protein per meal.</p>
              <p> Delivery within a 10 km radius.</p>
              <p>Access to customized meal options.</p>
              <p>Includes snacks and sides.</p>
            </ul>
            <button onClick={() => handlecheckout(10000)}>Subscribe Now</button>
          </div>
          <div>
            <h4>Muscle Gain/Weight Gain Meals</h4>
            <ul>
              <li>
                <strong>What we offer : </strong>
                High-protein and carb-rich meals designed to support muscle
                growth and weight gain.
              </li>
              <li>
                <strong>Why it’s ideal : </strong>
                Supports weight gain and builds muscle mass with higher calorie
                meals.
              </li>
              <li>
                <strong>Perfect for : </strong>
                Those on a muscle-building or weight gain journey.
              </li>
              <li>
                <strong>Meals per week : </strong>15 meals (7 dinners, 5
                lunches, 3 breakfasts)
              </li>
              <li>
                <strong>Price : </strong> ₹15000
              </li>
              <h5>Key Highlights</h5>
              <p>Average 50g+ protein per meal.</p>
              <p>Free delivery within a 15 km radius.</p>
              <p>Personalized nutrition consultations.</p>
              <p>Exclusive access to live kitchen updates.</p>
            </ul>
            <button onClick={() => handlecheckout(15000)}>Subscribe Now</button>
          </div>
        </div>
      </section> */}
      <section className="keyfeautures">
        <h2>Key Features</h2>
        <div className="grid">
          <div>
            <div className="img">
              <img src={hotfresh} alt="Hot & Fresh Meals" loading="lazy" />
            </div>
            <h3>Hot & Fresh Meals</h3>
            <p>
              Fresh, warm meals made to order with high-quality
              ingredients—Bhookr delivers flavor in every bite!
            </p>
          </div>
          <div>
            <div className="img">
              <img
                src={NutritionalSupport}
                alt="Nutritional Support"
                loading="lazy"
              />
            </div>
            <h3>Nutritional Support</h3>
            <p>
              Nutritionist-crafted meals tailored to your goals—high-protein,
              keto, or balanced options made easy!
            </p>
          </div>
          <div>
            <div className="img">
              <img
                src={calorie}
                alt="Calorie & Protein Counted"
                loading="lazy"
              />
            </div>
            <h3>Calorie & Protein Counted</h3>
            <p>
              Know your meals! Each dish is labeled with calories, protein, and
              nutrients to help you track intake and achieve health goals.
            </p>
          </div>

          <div>
            <div className="img">
              <img src={variety} alt="Variety of Meal Plans" loading="lazy" />
            </div>
            <h3>Variety of Meal Plans</h3>
            <p>
              Bhookr caters to vegetarian, non-veg, vegan, and keto diets with
              diverse meal plans and flavors—no more boring meals!
            </p>
          </div>
        </div>
      </section>

      <section className="faqshome">
        <h2>Faq's</h2>
        <Faqs />
        <div className="btncontainerhome">
          <button
            className="homerefbtn bhhokrpromisebtn"
            onClick={() => handleSubscriptionClick()}
          >
            Subscribe Now
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
